import { render } from "./SchoolBus.vue?vue&type=template&id=5721a794"
import script from "./SchoolBus.vue?vue&type=script&lang=js"
export * from "./SchoolBus.vue?vue&type=script&lang=js"

import "./SchoolBus.vue?vue&type=style&index=0&id=5721a794&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__